import { SWATCH_KINDS, type SwatchKind } from "@/components/primitives";

// Pick a default avatar swatch deterministically from a user id so the
// same user always sees the same default (even across reinstalls /
// devices) but new users distribute across the full swatch pool instead
// of all getting the same stripes default.
//
// Hash is a tiny FNV-1a 32-bit so we don't add a dependency.
export function pickDefaultAvatar(userId: string): SwatchKind {
  let h = 0x811c9dc5;
  for (let i = 0; i < userId.length; i++) {
    h ^= userId.charCodeAt(i);
    // Math.imul keeps the multiply in i32 territory.
    h = Math.imul(h, 0x01000193);
  }
  const idx = (h >>> 0) % SWATCH_KINDS.length;
  return SWATCH_KINDS[idx];
}
